/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FundFactSheetResponse
 */
export interface FundFactSheetResponse {
    /**
     * 
     * @type {string}
     * @memberof FundFactSheetResponse
     */
    url: string;
}

/**
 * Check if a given object implements the FundFactSheetResponse interface.
 */
export function instanceOfFundFactSheetResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function FundFactSheetResponseFromJSON(json: any): FundFactSheetResponse {
    return FundFactSheetResponseFromJSONTyped(json, false);
}

export function FundFactSheetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FundFactSheetResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['Url'],
    };
}

export function FundFactSheetResponseToJSON(value?: FundFactSheetResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Url': value.url,
    };
}

